module.exports = "@media (max-width: 1024px){.secondary-show{display:block}.secondary-hide{display:none}}\n"